import {
  CarbonIntensityEnv,
  getCarbonIntensityValue,
  HvacArea,
} from '@belimo-retrofit-portal/logic';
import { Decimal } from 'decimal.js-light';
import { pipe } from 'fp-ts/function';
import * as L from 'monocle-ts/Lens';
import { HvacFormData } from 'src/modules/hvac/types/HvacFormData';

export function resolveHvacFormData(
  environment: CarbonIntensityEnv,
  prevValues: HvacFormData,
  nextValues: HvacFormData,
): HvacFormData {
  return pipe(
    nextValues,

    resolveCarbonIntensity.bind(null, environment, HvacArea.HEATING, 'thermal', prevValues),
    resolveCarbonIntensity.bind(null, environment, HvacArea.COOLING, 'thermal', prevValues),
    resolveCarbonIntensity.bind(null, environment, HvacArea.VENTILATION, 'thermal', prevValues),

    resolveCarbonIntensity.bind(null, environment, HvacArea.HEATING, 'electrical', prevValues),
    resolveCarbonIntensity.bind(null, environment, HvacArea.COOLING, 'electrical', prevValues),
    resolveCarbonIntensity.bind(null, environment, HvacArea.VENTILATION, 'electrical', prevValues),
  );
}

function resolveCarbonIntensity(
  environment: CarbonIntensityEnv,
  hvacArea: HvacArea,
  energyType: 'thermal' | 'electrical',
  prevValues: HvacFormData,
  nextValues: HvacFormData,
): HvacFormData {
  const prevSource = prevValues.assessment.areas[hvacArea][energyType].energySource;
  const nextSource = nextValues.assessment.areas[hvacArea][energyType].energySource;
  if (prevSource === nextSource) {
    return nextValues;
  }

  const nextPredefinedValue = pipe(
    nextSource,
    getCarbonIntensityValue(environment),
    roundCarbonIntensity,
  );

  return pipe(
    L.id<HvacFormData>(),
    L.prop('assessment'),
    L.prop('areas'),
    L.prop(hvacArea),
    L.prop(energyType),
    L.prop('carbonIntensity'),
    L.modify(() => nextPredefinedValue),
  )(nextValues);
}

function roundCarbonIntensity(decimalValue: Decimal | null): Decimal | null {
  return decimalValue
    ? decimalValue.toDecimalPlaces(2)
    : null;
}
